import { Controller } from "@hotwired/stimulus"
import { reactor } from "../../lib/reactor"

export default class extends Controller {
  static values = {
    password: String,
    requireCurrent: Boolean
  }

  connect() {
    reactor(this)
  }

  passwordPresent() {
    return this.requireCurrentValue || (this.passwordValue || "").length > 0
  }
}
